<template>
  <div class="layout">
    <div class="layout__wrapper overflow-ellipsis">
      <input :value="params.data._id" name="selected" type="radio" :checked="isCurrentLayout" />
      <span :class="['layout__name', { 'layout__name--current': isCurrentLayout }]">
        {{ params.data.name }}
      </span>
    </div>
    <div v-if="isDeleteVisible">
      <v-icon small color="primary" @click.stop="params.onDeleteLayout(params.data)">
        mdi-delete-outline
      </v-icon>
    </div>
    <div v-else-if="isCurrentLayout && hasDeletePermission">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon small color="grey" class="delete-disabled" v-on="on"> mdi-delete-outline </v-icon>
        </template>
        <span>{{ $t('grid.layouts.messages.cannotDeleteActive') }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import { get } from 'lodash';

export default Vue.extend({
  name: 'AgGridLayoutRow',
  computed: {
    ...mapState('context', ['profile']),
    ...mapGetters('context', ['isOWUser']),
    ...mapGetters('gridLayouts', ['getActiveLayout']),
    hasDeletePermission() {
      return (
        get(this.params, 'data.createdBy._id', '') === get(this.profile, '_id', '') || this.isOWUser
      );
    },
    isDeleteVisible() {
      // Don't show delete button for active layout or if user doesn't have permission
      return this.hasDeletePermission && !this.isCurrentLayout;
    },
    isCurrentLayout() {
      const gridType = get(this.params, 'context.gridType');
      const activeLayout = this.getActiveLayout(gridType);
      return get(this.params, 'data._id') === get(activeLayout, '_id', '');
    },
  },
});
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  justify-content: space-between;
  width: 100%;

  &__wrapper {
    max-width: 300px;
    display: flex;
    align-items: center;
  }

  &__name {
    text-decoration: underline;
    padding-left: 10px;
    text-transform: capitalize;

    &--current {
      font-weight: bold;
    }
  }
}

input[type='radio'] {
  margin: 0;
}

.delete-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
